/* eslint-disable no-unsafe-optional-chaining */
/* eslint-disable no-case-declarations */
/* eslint-disable @typescript-eslint/no-use-before-define */
/* eslint-disable react-hooks/exhaustive-deps */
/* eslint-disable @typescript-eslint/no-non-null-assertion */
/* eslint-disable react/jsx-pascal-case */
/* eslint-disable no-loop-func */
/* eslint-disable no-nested-ternary */
/* eslint-disable react/jsx-no-useless-fragment */
/* eslint-disable no-await-in-loop */
/* eslint-disable react/no-array-index-key */
/* eslint-disable no-restricted-syntax */
import {
  Accordion,
  ActionIcon,
  Affix,
  Badge,
  Box,
  Button,
  Card,
  Center,
  Divider,
  Grid,
  Group,
  Input,
  Menu,
  Paper,
  Select,
  Stack,
  Table,
  Text,
  Title,
  Transition,
} from '@mantine/core';
import { DatePickerInput } from '@mantine/dates';
import { Dropzone, FileWithPath } from '@mantine/dropzone';
import { useForm } from '@mantine/form';
import { useWindowScroll } from '@mantine/hooks';
import { closeAllModals, useModals } from '@mantine/modals';
import { showNotification } from '@mantine/notifications';
import {
  IconArrowNarrowUp,
  IconArrowRight,
  IconBuilding,
  IconCalendar,
  IconCertificate,
  IconEye,
  IconFileCheck,
  IconLink,
  IconPlus,
  IconSearch,
  IconUpload,
  IconX,
} from '@tabler/icons-react';
import lodash from 'lodash';
import moment from 'moment';
import { ReactNode, useCallback, useEffect, useMemo, useState } from 'react';
import { ContractStatusEnum } from '../../../business/contracts/status';
import {
  AudienciaCodigo,
  EventBulkUpdateEnum,
  Fonte,
  ReferenciaCodigo,
  Status,
  TipoCodigo,
} from '../../../business/events/general';
import { ForwardRefMultiSelect } from '../../../components/core/ForwardRefMultiSelect/ForwardRefMultiSelect';
import PageContent from '../../../components/core/PageContent/PageContent';
import PageHeader from '../../../components/core/PageHeader/PageHeader';
import ProfileCardLink from '../../../components/core/ProfileCardLink/ProfileCardLink';
import { EventGeneralProvider } from '../../../contexts/core/events/EventGeneral.context';
import useCurrentUser from '../../../hooks/useCurrentUser';
import useDynamicRefs from '../../../hooks/useDynamicRefs';
import {
  CompanyType,
  ContractStatusType,
  DocumentType,
  DocumentTypeGroup,
  EntityTypeType,
  EventRelationTypeData,
  EventStatusReasonType,
  EventStatusType,
  MovementType,
  ProposalStatusType,
  UnitOfMeasureType,
} from '../../../models/core/cache.type';
import { ContractSearchResponseType } from '../../../models/core/contracts.type';
import { EventSearchResponseType } from '../../../models/core/events.type';
import { EventDocumentMatchResponseType } from '../../../models/core/integrations.type';
import { UserType } from '../../../models/core/users.type';
import contractsService from '../../../services/core/contracts.service';
import eventsService from '../../../services/core/events.service';
import integrationsService from '../../../services/core/integrations.service';
import usersService from '../../../services/core/users.service';
import qiveService from '../../../services/utils/qive.service';
import cacheUtils from '../../../utils/cache.utils';
import { Feature } from '../../../utils/constants.utils';
import { formatDateToString } from '../../../utils/formatter.utils';
import { buildFakeAuditObject, formatCNPJ, newGuid } from '../../../utils/helper.utils';
import EventAddEdit from '../../core/events/EventAddEdit/EventAddEdit';
import EventView from '../../core/events/EventView/EventView';

type FilterData = {
  idEmpresa: string | null;
  periodo: Date[];
};

interface NFe {
  numero: string;
  data: Date;
  chave: string;
  emitenteDestinatarioGrupo: string;
  semContrato: boolean;
  correlacionadoCom: number[];
  emitente: {
    cnpj: string;
    nome: string;
    nomeFantasia: string | null;
  };
  destinatario: {
    cnpj: string;
    nome: string;
    nomeFantasia: string | null;
  };
  produtos: {
    produto: string;
    unidade: string;
    quantidade: string;
    valorUnitario: number;
    valor: number;
  }[];
  eventos: EventDocumentMatchResponseType[];
  eventosLinkados: EventSearchResponseType[];
}

interface Summary {
  minData: Date;
  maxData: Date;
  emitentesDistintos: {
    cnpj: string;
    nome: string;
    nomeFantasia: string | null;
    minData: Date;
    maxData: Date;
    numeroNFes: string[];
    noContracts: boolean;
  }[];
}

function IntegrationNFe() {
  const [currentUser] = useCurrentUser();
  const [getRef, setRef] = useDynamicRefs();
  const modals = useModals();
  const zIndex = 10000;

  const [scroll, scrollTo] = useWindowScroll();

  const [filterData, setFilterData] = useState<{
    companyData: CompanyType[];
    proposalStatusData: ProposalStatusType[];
    contractStatusData: ContractStatusType[];
    eventStatusData: EventStatusType[];
    userData: UserType[];
    entityTypeData: EntityTypeType[];
    unitOfMeasures: UnitOfMeasureType[];
    documentTypeData: DocumentType[];
    movementTypeData: MovementType[];
    eventRelationTypeData: EventRelationTypeData[];
    eventStatusReasonData: EventStatusReasonType[];
  }>({
    companyData: [],
    proposalStatusData: [],
    contractStatusData: [],
    eventStatusData: [],
    userData: [],
    entityTypeData: [],
    unitOfMeasures: [],
    documentTypeData: [],
    movementTypeData: [],
    eventRelationTypeData: [],
    eventStatusReasonData: [],
  });

  const [loading, setLoading] = useState(false);
  const [result, setResult] = useState<{
    idDocumentoTipo: number;
    nfes: NFe[];
    summary: Summary;
    eventos: EventDocumentMatchResponseType[];
    contratos: ContractSearchResponseType[];
  } | null>(null);

  const form = useForm<FilterData>({
    initialValues: {
      idEmpresa: currentUser.executivo ? null : currentUser.idEmpresa.toString(),
      periodo: [
        new Date(moment(new Date()).startOf('month').add(1, 'days').format('yyyy-MM-DD')),
        new Date(),
      ],
    },
  });

  const reset = (resetForm: boolean) => {
    setResult(null);
    if (resetForm) {
      form.reset();
      form.setFieldValue('periodo', []);
    }
    scrollTo({ y: 0 });
  };

  const hasNoContracts = (cnpj: string, contracts: ContractSearchResponseType[]) => {
    return contracts.findIndex((x) => [x.clienteCNPJ, x.clienteCPF].includes(cnpj)) === -1;
  };

  const parseNFe = (text: string, contracts: ContractSearchResponseType[]) => {
    const parser = new DOMParser();
    const xml = parser.parseFromString(text, 'text/xml');

    const getText = (tag: string): string => xml.querySelector(tag)?.textContent?.trim() ?? '';

    if (!getText('nfeProc')) return null;

    const numero = getText('ide > nNF');
    const dataEmissao = new Date(getText('ide > dhEmi'));
    const chave = getText('infProt > chNFe');

    const emitente = {
      cnpj: formatCNPJ(getText('emit > CNPJ')),
      nome: getText('emit > xNome'),
      nomeFantasia: getText('emit > xFant') || null,
    };

    const destinatario = {
      cnpj: formatCNPJ(getText('dest > CNPJ')),
      nome: getText('dest > xNome'),
      nomeFantasia: getText('dest > xFant') || null,
    };

    const produtos: NFe['produtos'] = Array.from(xml.querySelectorAll('det')).map((det) => {
      const prod = det.querySelector('prod');
      return {
        produto: prod?.querySelector('xProd')?.textContent ?? '',
        unidade: prod?.querySelector('uCom')?.textContent ?? '',
        quantidade: prod?.querySelector('qCom')?.textContent ?? '',
        valorUnitario: parseFloat(prod?.querySelector('vUnCom')?.textContent ?? '0'),
        valor: parseFloat(prod?.querySelector('vProd')?.textContent ?? '0'),
      };
    });

    return {
      numero,
      data: dataEmissao,
      chave,
      emitenteDestinatarioGrupo:
        (emitente.nomeFantasia ?? emitente.nome) + (destinatario.nomeFantasia ?? destinatario.nome),
      semContrato: hasNoContracts(emitente.cnpj, contracts),
      correlacionadoCom: [],
      emitente,
      destinatario,
      produtos,
      eventos: [],
      eventosLinkados: [],
    } as NFe;
  };

  function summarizeNFes(nfes: NFe[]): Summary {
    const datas = nfes.map((nfe) => new Date(nfe.data).getTime());
    const emitentes = new Map<
      string,
      {
        cnpj: string;
        nome: string;
        nomeFantasia: string | null;
        minData: Date;
        maxData: Date;
        numeroNFes: string[];
        noContracts: boolean;
      }
    >();

    nfes.forEach(({ emitente, data, semContrato, numero }) => {
      const time = new Date(data).getTime();
      if (!emitentes.has(emitente.cnpj)) {
        emitentes.set(emitente.cnpj, {
          ...emitente,
          minData: new Date(time),
          maxData: new Date(time),
          numeroNFes: [numero],
          noContracts: semContrato,
        });
      } else {
        const e = emitentes.get(emitente.cnpj)!;
        e.minData = new Date(Math.min(e.minData.getTime(), time));
        e.maxData = new Date(Math.max(e.maxData.getTime(), time));
        e.numeroNFes.push(numero);
      }
    });

    return {
      minData: new Date(Math.min(...datas)),
      maxData: new Date(Math.max(...datas)),
      emitentesDistintos: Array.from(emitentes.values()),
    };
  }

  const processInBatches = async <TItem, TResult>(
    items: TItem[],
    batchSize: number,
    callback: (item: TItem) => Promise<TResult>
  ) => {
    const results: TResult[] = [];

    for (let index = 0; index < items.length; index += batchSize) {
      const batch = items.slice(index, index + batchSize);
      const batchResults = await Promise.all(batch.map(callback));
      results.push(...batchResults);
    }

    return results;
  };

  const handleReject = () => {
    setResult(null);
    showNotification({
      title: `Correlacionar NFe(s)'`,
      message: 'Limite máximo de 500 arquivos atingido.',
      color: 'red',
    });
  };

  const processNFeXmls = async (xmlContents: string[]) => {
    const documentoTipo = 'Nota Fiscal';
    const idDocumentoTipo =
      (await cacheUtils.listDocumentTypes())
        .filter((x) => x.codigoDocumentoGrupo === DocumentTypeGroup.Event)
        .find((x) => x.documentoTipo === documentoTipo)?.idDocumentoTipo ?? -1;

    const contracts = await contractsService.search({
      listaStatus: [
        ContractStatusEnum.AguardandoInicio,
        ContractStatusEnum.EmAndamento,
        ContractStatusEnum.EmProcessamento,
        ContractStatusEnum.EmSubstituicao,
        ContractStatusEnum.Reconciliando,
      ],
      limit: 1000,
      offset: 0,
    });

    const nfes =
      (
        await Promise.all(
          xmlContents.map(async (text) => {
            const nfe = parseNFe(text, contracts);
            return nfe;
          })
        )
      )?.filter(
        (x): x is NFe =>
          x !== null &&
          x.data >= form.values.periodo[0] &&
          x.data <= moment(form.values.periodo[1]).endOf('day').toDate()
      ) ?? [];

    if (nfes.length === 0) {
      throw new Error('Nenhuma NFe encontrada para processar.');
    }

    const summary = summarizeNFes(nfes);

    const eventosSugeridos = (
      await processInBatches(summary.emitentesDistintos, 3, async (emitente) => {
        return integrationsService.eventDocumentMatchGet({
          idEmpresa: form.values.idEmpresa,
          idDocumentoTipo,
          dataInicial: moment(emitente.minData).add(-3, 'days').toISOString(),
          dataFinal: moment(emitente.maxData).add(3, 'days').toISOString(),
          listaCnpjCpf: [emitente.cnpj.replace(/\D/g, '')],
        });
      })
    ).flat();

    const eventosLinkados = (
      await processInBatches(summary.emitentesDistintos, 3, async (emitente) => {
        return eventsService.search({
          idEmpresa: form.values.idEmpresa,
          idDocumentoTipo: idDocumentoTipo.toString(),
          listaNumeroDocumento: emitente.numeroNFes,
          limit: 1000,
          offset: 0,
        });
      })
    ).flat();

    for (const nfe of nfes) {
      nfe.eventos = eventosSugeridos
        .filter(
          (x) =>
            [x.cnpj, x.cpf].includes(nfe.emitente.cnpj) &&
            Math.abs(moment(x.data, 'YYYY-MM-DD').diff(moment(nfe.data, 'dd/MM/yyyy HH:mm'), 'days')) <= 3
        )
        .sort((a, b) => {
          const nfeData = moment(nfe.data, 'dd/MM/yyyy HH:mm');
          const diffA = Math.abs(moment(a.data).diff(nfeData));
          const diffB = Math.abs(moment(b.data).diff(nfeData));
          return diffA - diffB;
        });

      nfe.eventosLinkados = eventosLinkados.filter((x) =>
        x.resumoParcialJSON?.documentos?.find(
          (y) => y.documentoTipo === documentoTipo && y.numeroDocumento === nfe.numero
        )
      );
    }

    return {
      idDocumentoTipo,
      nfes,
      summary,
      eventos: eventosSugeridos,
      contratos: contracts,
    };
  };

  const handleDrop = useCallback(async (files: FileWithPath[]) => {
    try {
      reset(false);
      setLoading(true);
      const xmlFiles = files.filter((file) => file.name.endsWith('.xml'));
      const xmlContents = await Promise.all(xmlFiles.map(async (file) => file.text()));
      const processResult = await processNFeXmls(xmlContents);
      setResult(processResult);

      showNotification({
        title: `Correlacionar NFe(s)'`,
        message: 'NFe(s) importa(s) com sucesso.',
        color: 'green',
      });
    } catch (error) {
      setResult(null);
      showNotification({
        title: `Correlacionar NFe(s)'`,
        message: 'Não foi possível importar a(s) NFe(s).',
        color: 'red',
      });
    } finally {
      setLoading(false);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const handleDropFromUrls = async () => {
    try {
      reset(false);
      setLoading(true);

      const qiveDocuments = await qiveService.listarNFesRecebidasPorPeriodo(
        form.values.periodo[0],
        form.values.periodo[1]
      );
      const processResult = await processNFeXmls(qiveDocuments.map((x) => x.xml));
      setResult(processResult);

      showNotification({
        title: `Correlacionar NFe(s)'`,
        message: 'NFe(s) importada(s) com sucesso.',
        color: 'green',
      });
    } catch (error) {
      setResult(null);
      showNotification({
        title: `Correlacionar NFe(s)'`,
        message: 'Não foi possível buscar a(s) NFe(s).',
        color: 'red',
      });
    } finally {
      setLoading(false);
    }
  };

  const buildNFeTable = useMemo(() => {
    const nodes: ReactNode[] = [];

    const handleLinkAction = async (nfeChave: string, listaIdEventos: string[], newEvent: boolean) => {
      if (!result || listaIdEventos?.length === 0) {
        return;
      }

      const nfeAtual = result.nfes.find((x) => x.chave === nfeChave)!;
      const produto = nfeAtual.produtos.length === 1 ? nfeAtual.produtos[0] : null;

      try {
        setLoading(true);

        for (const idEvento of listaIdEventos.map((x) => Number(x))) {
          await eventsService.insertDocument({
            ...buildFakeAuditObject(),
            action: 'add',
            idEvento,
            idDocumentoTipo: result.idDocumentoTipo,
            outroTipo: null,
            numeroDocumento: nfeAtual.numero,
            data: nfeAtual.data,
            observacao: produto
              ? `${nfeAtual.chave}|${produto.produto.substring(0, 400)}|${produto.quantidade}|${
                  produto.unidade
                }|${produto.valorUnitario}`
              : 'Vários itens',
            arquivos: [],
          });

          for (const nfe of result.nfes) {
            if (nfe.chave === nfeChave) {
              nfe.correlacionadoCom?.push(idEvento);
            }
            nfe.eventos = nfe.eventos.filter((x) => x.idEvento !== idEvento);
          }
        }

        // change the status to Agendado
        let eventos = result.eventos.filter(
          (x) => listaIdEventos.includes(x.idEvento.toString()) && x.codigoEventoStatus === Status.Pendente
        );

        if (eventos.length > 0) {
          const eventosSemResponsavel = eventos.filter((x) => !x.idResponsavel);
          if (eventosSemResponsavel.length > 0) {
            await eventsService.bulkUpdate({
              acao: EventBulkUpdateEnum.Responsavel,
              idResponsavel: currentUser.idUsuario,
              listaIdEvento: eventosSemResponsavel.map((x) => x.idEvento),
              codigoEventoStatus: null,
            });
          }

          await eventsService.bulkUpdate({
            acao: EventBulkUpdateEnum.Status,
            codigoEventoStatus: Status.Agendado,
            idResponsavel: null,
            listaIdEvento: eventos.map((x) => x.idEvento),
          });

          // update result set
          result.eventos = result.eventos.map((x) => {
            if (listaIdEventos.includes(x.idEvento.toString()) && x.codigoEventoStatus === Status.Pendente) {
              return {
                ...x,
                codigoEventoStatus: Status.Agendado,
                idResponsavel: x.idResponsavel ?? currentUser.idUsuario,
              };
            }
            return x;
          });
        }

        // change the status to PendenteMedicao
        eventos = result.eventos.filter(
          (x) => listaIdEventos.includes(x.idEvento.toString()) && x.codigoEventoStatus === Status.Agendado
        );

        if (newEvent) {
          eventos = [
            {
              idResponsavel: currentUser.idUsuario,
              idEvento: Number(listaIdEventos[0]),
              codigoEventoStatus: Status.Agendado,
            } as EventDocumentMatchResponseType,
          ];
        }

        if (eventos.length > 0) {
          const eventosSemResponsavel = eventos.filter((x) => !x.idResponsavel);
          if (eventosSemResponsavel.length > 0) {
            await eventsService.bulkUpdate({
              acao: EventBulkUpdateEnum.Responsavel,
              idResponsavel: currentUser.idUsuario,
              listaIdEvento: eventosSemResponsavel.map((x) => x.idEvento),
              codigoEventoStatus: null,
            });
          }

          await eventsService.bulkUpdate({
            acao: EventBulkUpdateEnum.Status,
            codigoEventoStatus: Status.PendenteMedicao,
            idResponsavel: null,
            listaIdEvento: eventos.map((x) => x.idEvento),
          });
        }

        setResult(JSON.parse(JSON.stringify(result)));
      } catch {
        showNotification({
          title: `Correlacionar NFe(s)'`,
          message: 'Não foi correlacionar essa NFe.',
          color: 'red',
        });
      } finally {
        setLoading(false);
      }
    };

    const newEvent = (item: NFe, produtoIndex: number, contratos: ContractSearchResponseType[]) => {
      closeAllModals();
      modals.openModal({
        title: 'Evento - Adicionar',
        size: '70%',
        closeOnClickOutside: false,
        children: (
          <EventGeneralProvider>
            <EventAddEdit
              idEvento={undefined}
              newEventData={{
                idEmpresa: Number(form.values.idEmpresa),
                codigoAudiencia: AudienciaCodigo.Operacional,
                codigoEventoTipo: TipoCodigo.Coleta,
                fonte: Fonte.Contrato,
                contrato: contratos?.[0] ?? null,
                codigoReferencia: ReferenciaCodigo.ContratoResiduoPlano,
                idUsuario: currentUser.idUsuario,
                data: new Date(item.data),
                descricao: item.produtos?.[produtoIndex]?.produto || null,
              }}
              referenceData={filterData}
              zIndex={zIndex}
              callback={confirmActionResult}
              extras={item}
            />
          </EventGeneralProvider>
        ),
      });
    };

    const viewEvent = (item: EventSearchResponseType, nfe: NFe) => {
      closeAllModals();
      modals.openModal({
        title: (
          <Group>
            <Text>Evento - Visualizar (#{item.idEvento})</Text>
            {item.obsoleto ? (
              <Badge variant="outline" color="red" size="sm">
                obsoleto
              </Badge>
            ) : (
              ''
            )}
          </Group>
        ),
        size: '80%',
        closeOnClickOutside: false,
        children: (
          <EventView
            referenceData={filterData}
            idEvento={item.idEvento}
            zIndex={zIndex}
            callback={confirmActionResult}
            extras={nfe}
          />
        ),
      });
    };

    const confirmActionResult = async (
      items: EventSearchResponseType[],
      action: string,
      value: string | null,
      confirmed: boolean,
      extras: NFe
    ) => {
      if (!confirmed) {
        return;
      }

      if (action.startsWith('documento') && value !== extras?.numero) {
        return;
      }

      const item = items?.[0];

      try {
        // let completedAction;
        setLoading(true);

        if (!action.startsWith('documento')) {
          closeAllModals();
        }

        switch (action) {
          case 'callback':
            if (extras?.chave) {
              await handleLinkAction(extras.chave, [item.idEvento.toString()], true);
            }
            break;
          case 'callback-remover':
          case 'documento-excluir':
            for (const nfe of result!.nfes) {
              nfe.eventos = nfe.eventos.filter((x) => x.idEvento !== item.idEvento);
              nfe.correlacionadoCom = nfe.correlacionadoCom.filter((x) => x !== item.idEvento);
              nfe.eventosLinkados = nfe.eventosLinkados.filter((x) => x.idEvento !== item.idEvento);
            }
            result!.eventos = result!.eventos.filter((x) => x.idEvento !== item.idEvento);
            setResult(JSON.parse(JSON.stringify(result)));
            break;
          default:
            break;
        }

        // showNotification({
        //   title: 'Eventos',
        //   message: `Evento ${completedAction} com sucesso.`,
        //   color: 'green',
        // });
      } catch (error: any) {
        showNotification({
          title: 'Eventos',
          message: error?.isBusinessException ? error.description : `Não foi possível ${action} o evento.`,
          color: 'red',
        });
      } finally {
        setLoading(false);
      }
    };

    const emitenteDestinatarioGrupo = lodash.groupBy(result?.nfes, 'emitenteDestinatarioGrupo');

    for (const key of Object.keys(emitenteDestinatarioGrupo).sort((a: any, b: any) => a.localeCompare(b))) {
      const items = emitenteDestinatarioGrupo[key];
      const item0 = items[0];
      const item0Summary = result?.summary.emitentesDistintos.find((x) => x.cnpj === item0.emitente.cnpj);
      const contratos =
        result?.contratos
          .filter((x) => [x.clienteCNPJ, x.clienteCPF].includes(item0.emitente.cnpj))
          ?.sort((a, b) => b.idContrato - a.idContrato) ?? [];

      nodes.push(
        <Accordion
          variant="contained"
          key={`a_${item0.emitenteDestinatarioGrupo}`}
          defaultValue={item0Summary?.noContracts ? null : item0.emitente.cnpj}
          mt="md"
        >
          <Accordion.Item key={`a_i_${item0.emitenteDestinatarioGrupo}`} value={item0.emitente.cnpj}>
            <Accordion.Control>
              <Group justify="space-between">
                <Group gap="lg">
                  <ProfileCardLink
                    id={item0.emitente.cnpj}
                    name={item0.emitente.nomeFantasia || item0.emitente.nome || '-'}
                    nameSize="sm"
                    description={item0.emitente.nomeFantasia ? item0.emitente.nome : item0.emitente.cnpj}
                    descriptionSize="xs"
                    showLink={false}
                  />
                  <IconArrowRight size={18} />
                  <ProfileCardLink
                    id={item0.destinatario.cnpj}
                    name={item0.destinatario.nomeFantasia || item0.destinatario.nome || '-'}
                    nameSize="sm"
                    description={
                      item0.destinatario.nomeFantasia ? item0.destinatario.nome : item0.destinatario.cnpj
                    }
                    descriptionSize="xs"
                    showLink={false}
                  />
                </Group>
                <Group>
                  {item0Summary?.noContracts ? (
                    <Badge variant="outline" color="orange">
                      Emitente sem contrato
                    </Badge>
                  ) : items.every((x) => x.eventosLinkados.length > 0) ? (
                    <Badge variant="outline" color="blue">
                      NFe(s) já correlacionada(s)
                    </Badge>
                  ) : (
                    items.reduce((a, b) => a + b.eventos.length, 0) === 0 && (
                      <Badge variant="outline" color="red">
                        Nenhum evento sugerido
                      </Badge>
                    )
                  )}
                </Group>
              </Group>
            </Accordion.Control>
            <Accordion.Panel>
              <Paper mt="md" withBorder p="md">
                <Table striped highlightOnHover withTableBorder withColumnBorders>
                  <Table.Thead>
                    <Table.Tr>
                      <Table.Th>Número</Table.Th>
                      <Table.Th>Data</Table.Th>
                      <Table.Th>Itens</Table.Th>
                      <Table.Th>Ações</Table.Th>
                    </Table.Tr>
                  </Table.Thead>
                  <Table.Tbody>
                    {items.map((item) => (
                      <Table.Tr key={`t_tr_${item.chave}`}>
                        <Table.Td>{item.numero}</Table.Td>
                        <Table.Td>{formatDateToString(item.data)}</Table.Td>
                        <Table.Td>
                          <Table key={`t_${item.chave}`} withTableBorder withColumnBorders withRowBorders>
                            <Table.Thead>
                              <Table.Tr>
                                <Table.Th>Item</Table.Th>
                                <Table.Th>Unidade</Table.Th>
                                <Table.Th>Quantidade</Table.Th>
                                <Table.Th>Valor Unitário</Table.Th>
                                <Table.Th>Valor Total</Table.Th>
                                <Table.Th>Ações</Table.Th>
                              </Table.Tr>
                            </Table.Thead>
                            <Table.Tbody>
                              {item.produtos.map((p, i) => (
                                <Table.Tr key={`t_tr_p_${i}`}>
                                  <Table.Td>{p.produto}</Table.Td>
                                  <Table.Td>{p.unidade}</Table.Td>
                                  <Table.Td>{p.quantidade}</Table.Td>
                                  <Table.Td>{p.valorUnitario.toFixed(2)}</Table.Td>
                                  <Table.Td>{p.valor.toFixed(2)}</Table.Td>
                                  <Table.Td width={45}>
                                    {!item.semContrato ? (
                                      <Button
                                        leftSection={<IconPlus size={14} />}
                                        color="primary"
                                        size="xs"
                                        onClick={() => {
                                          newEvent(item, i, contratos);
                                        }}
                                      >
                                        Evento
                                      </Button>
                                    ) : (
                                      <>-</>
                                    )}
                                  </Table.Td>
                                </Table.Tr>
                              ))}
                            </Table.Tbody>
                          </Table>
                        </Table.Td>
                        <Table.Td width={355}>
                          {item.eventos.length === 0 &&
                          item.correlacionadoCom?.length + item.eventosLinkados?.length === 0 ? (
                            <Badge variant="outline" color="red">
                              Nenhum evento sugerido
                            </Badge>
                          ) : (
                            <>
                              {item.eventos.length > 0 && (
                                <Group gap="xs" grow>
                                  <ForwardRefMultiSelect
                                    key={`s_nfe_event_${item.chave}_${
                                      item.eventosLinkados.length + item.correlacionadoCom.length
                                    }`}
                                    ref={setRef(`s_nfe_event_${item.chave}`)}
                                    leftSection={<Feature.Home.Event.icon size={15} />}
                                    maxDropdownHeight={400}
                                    style={{ minWidth: 300 }}
                                    renderOption={({ option }) => {
                                      const evento = result?.eventos.find(
                                        (x) => x.idEvento === Number(option.value)
                                      );
                                      if (!evento) {
                                        return <div>{option.label}</div>;
                                      }

                                      const { residuo, veiculo, tratamento, destinoFinal } =
                                        evento.resumoJSON!;

                                      return (
                                        <Paper shadow="xs" p="md" withBorder style={{ minWidth: 250 }}>
                                          <>
                                            <Divider
                                              my="sm"
                                              variant="dashed"
                                              label={`#${evento.idEvento}`}
                                              labelPosition="center"
                                            />
                                            <Group justify="space-between" wrap="nowrap">
                                              <Badge size="sm" variant="outline">
                                                {
                                                  filterData.eventStatusData.find(
                                                    (x) => x.codigoEventoStatus === evento.codigoEventoStatus
                                                  )?.eventoStatus
                                                }
                                              </Badge>
                                              <Text size="sm">{formatDateToString(evento.data)} </Text>
                                            </Group>
                                          </>

                                          <>
                                            <Divider
                                              my="sm"
                                              variant="dashed"
                                              label={
                                                <Group>
                                                  <Feature.Reference.Residue.icon size={15} />
                                                  Resíduo
                                                </Group>
                                              }
                                              labelPosition="center"
                                            />
                                            <Stack gap="xs">
                                              <Text size="sm">{residuo?.residuoCliente}</Text>
                                              <Text fs="italic" size="xs">
                                                {residuo?.residuo}
                                              </Text>
                                            </Stack>
                                          </>

                                          {veiculo && (
                                            <>
                                              <Divider
                                                my="sm"
                                                variant="dashed"
                                                label={
                                                  <Group>
                                                    <Feature.Reference.Vehicle.icon size={15} />
                                                    {veiculo.residuoVeiculo}
                                                  </Group>
                                                }
                                                labelPosition="center"
                                              />
                                              <Group>
                                                <Text size="xs">
                                                  {veiculo?.cotacao.fornecedorNomeFantasia ||
                                                    veiculo?.cotacao.fornecedorRazaoSocial}
                                                </Text>
                                              </Group>
                                            </>
                                          )}

                                          {tratamento && (
                                            <>
                                              <Divider
                                                my="sm"
                                                variant="dashed"
                                                label={
                                                  <Group>
                                                    <Feature.Reference.Treatment.icon size={15} />
                                                    {tratamento.residuoTratamento}
                                                  </Group>
                                                }
                                                labelPosition="center"
                                              />
                                              <Group>
                                                <Text size="xs">
                                                  {tratamento?.cotacao.fornecedorNomeFantasia ||
                                                    tratamento?.cotacao.fornecedorRazaoSocial}
                                                </Text>
                                              </Group>
                                            </>
                                          )}

                                          {destinoFinal && (
                                            <>
                                              <Divider
                                                my="sm"
                                                variant="dashed"
                                                label={
                                                  <Group>
                                                    <Feature.Reference.Destination.icon size={15} />
                                                    {destinoFinal.residuoDestinoFinal}
                                                  </Group>
                                                }
                                                labelPosition="center"
                                              />
                                              <Group>
                                                <Text size="xs">
                                                  {destinoFinal?.cotacao.fornecedorNomeFantasia ||
                                                    destinoFinal?.cotacao.fornecedorRazaoSocial}
                                                </Text>
                                              </Group>
                                            </>
                                          )}

                                          {evento.resumoJSON?.documentos && (
                                            <>
                                              <Divider
                                                my="sm"
                                                variant="dashed"
                                                label={
                                                  <Group>
                                                    <IconCertificate size={15} />
                                                    Documentos
                                                  </Group>
                                                }
                                                labelPosition="center"
                                              />
                                              <Group gap="xs">
                                                {evento.resumoJSON.documentos.map((y) => {
                                                  return (
                                                    <Group gap="xs" key={newGuid()}>
                                                      <Badge
                                                        key={newGuid()}
                                                        variant="outline"
                                                      >{`${y.documentoTipo} - ${y.numeroDocumento}`}</Badge>
                                                      {y.observacao?.split('|')?.length ===
                                                        (y.documentoTipo === 'MTR'
                                                          ? 3
                                                          : y.documentoTipo === 'Nota Fiscal'
                                                          ? 5
                                                          : -2) && (
                                                        <Badge
                                                          key={newGuid()}
                                                          style={{ marginLeft: -10 }}
                                                          color="green"
                                                          variant="outline"
                                                        >
                                                          {y.documentoTipo === 'MTR'
                                                            ? `${y.observacao.split('|')[1]} - ${
                                                                y.observacao.split('|')[2]
                                                              }`
                                                            : `${y.observacao.split('|')[2]} - ${
                                                                y.observacao.split('|')[3]
                                                              }`}
                                                        </Badge>
                                                      )}
                                                    </Group>
                                                  );
                                                })}
                                              </Group>
                                            </>
                                          )}
                                        </Paper>
                                      );
                                    }}
                                    label="Eventos"
                                    placeholder="Selecione..."
                                    data={item.eventos.map((x) => ({
                                      value: x.idEvento.toString(),
                                      label: `${x.idEvento} - ${x.resumoJSON?.residuo?.residuoCliente}`,
                                    }))}
                                    searchable
                                    clearable
                                  />
                                  <Input.Wrapper>
                                    <Input.Label> </Input.Label>
                                    <Input.Wrapper>
                                      <ActionIcon
                                        size="sm"
                                        color="green"
                                        variant="outline"
                                        onClick={async () => {
                                          const ref = getRef(`s_nfe_event_${item.chave}`)?.current;
                                          await handleLinkAction(
                                            item.chave,
                                            ref?.getSelectedValues() ?? [],
                                            false
                                          );
                                        }}
                                      >
                                        <IconLink size={18} />
                                      </ActionIcon>
                                    </Input.Wrapper>
                                  </Input.Wrapper>
                                </Group>
                              )}
                              {item.correlacionadoCom?.length + item.eventosLinkados?.length > 0 && (
                                <Center mt={item.eventos.length > 0 ? 'md' : undefined}>
                                  <Menu withArrow zIndex={zIndex}>
                                    <Menu.Target>
                                      <Button
                                        color={
                                          item.correlacionadoCom?.length > 0
                                            ? 'green'
                                            : `${Feature.Home.Event.color}.4`
                                        }
                                        leftSection={<IconEye size={14} />}
                                        size="xs"
                                      >
                                        {`${'Correlacionado com '} ${
                                          item.correlacionadoCom?.length + item.eventosLinkados?.length
                                        } ${
                                          item.correlacionadoCom?.length + item.eventosLinkados?.length > 1
                                            ? 'eventos'
                                            : 'evento'
                                        }`}
                                      </Button>
                                    </Menu.Target>

                                    <Menu.Dropdown style={{ minWidth: 150 }}>
                                      {item.correlacionadoCom.map((x) => (
                                        <Menu.Item
                                          key={item.chave + x}
                                          leftSection={<Feature.Home.Event.icon size={14} />}
                                          color="green"
                                          onClick={() => {
                                            viewEvent({ idEvento: Number(x) } as any, item);
                                          }}
                                        >
                                          {x}
                                        </Menu.Item>
                                      ))}
                                      {item.eventosLinkados.map((x) => (
                                        <>
                                          <Menu.Item
                                            key={item.chave + x.idEvento}
                                            leftSection={x.idEvento}
                                            color={`${Feature.Home.Event.color}.4`}
                                            onClick={() => {
                                              viewEvent(x, item);
                                            }}
                                          >
                                            <>
                                              <Stack gap="xs">
                                                {x.resumoParcialJSON?.documentos?.map((y) => {
                                                  return (
                                                    <Group gap="xs" key={newGuid()}>
                                                      <Badge
                                                        key={newGuid()}
                                                        variant="outline"
                                                        size="sm"
                                                      >{`${y.documentoTipo} - ${y.numeroDocumento}`}</Badge>
                                                      {y.observacao?.split('|')?.length ===
                                                        (y.documentoTipo === 'MTR'
                                                          ? 3
                                                          : y.documentoTipo === 'Nota Fiscal'
                                                          ? 5
                                                          : -2) && (
                                                        <Badge
                                                          key={newGuid()}
                                                          style={{ marginLeft: -10 }}
                                                          color="green"
                                                          variant="outline"
                                                        >
                                                          {y.documentoTipo === 'MTR'
                                                            ? `${y.observacao.split('|')[1]} - ${
                                                                y.observacao.split('|')[2]
                                                              }`
                                                            : `${y.observacao.split('|')[2]} - ${
                                                                y.observacao.split('|')[3]
                                                              }`}
                                                        </Badge>
                                                      )}
                                                    </Group>
                                                  );
                                                })}
                                              </Stack>
                                            </>
                                          </Menu.Item>
                                          <Divider key={`divider_${item.numero}_${x.idEvento}`} />
                                        </>
                                      ))}
                                    </Menu.Dropdown>
                                  </Menu>
                                </Center>
                              )}
                            </>
                          )}
                        </Table.Td>
                      </Table.Tr>
                    ))}
                  </Table.Tbody>
                </Table>
              </Paper>
            </Accordion.Panel>
          </Accordion.Item>
        </Accordion>
      );
    }

    return nodes;
  }, [filterData.eventStatusData, getRef, result, setRef]);

  useEffect(() => {
    const loadFilterData = async () => {
      setLoading(true);

      setFilterData({
        companyData: await cacheUtils.listCompanies(),
        proposalStatusData: await cacheUtils.listProposalStatuses(),
        contractStatusData: await cacheUtils.listContractStatuses(),
        eventStatusData: await cacheUtils.listEventStatuses(),
        userData: await usersService.search({
          limit: 1000,
          offset: 0,
        }),
        entityTypeData: await cacheUtils.listEntityTypes(),
        unitOfMeasures: await cacheUtils.listUnityOfMeasures(),
        documentTypeData: (await cacheUtils.listDocumentTypes()).filter(
          (x) => x.codigoDocumentoGrupo === DocumentTypeGroup.Event || !x.codigoDocumentoGrupo
        ),
        movementTypeData: await cacheUtils.listMovementTypes(),
        eventRelationTypeData: await cacheUtils.listEventRelationTypes(),
        eventStatusReasonData: await cacheUtils.listEventStatusReasonTypes(),
      });

      setLoading(false);
    };

    loadFilterData();
  }, []);

  return (
    <Card>
      <PageHeader
        feature={Feature.Home.Integration}
        title="Correlacionar NFe(s)"
        description="Busque NF-e(s) na Qive por período ou importe manualmente arquivos XML para correlacionar a eventos."
        buttons={[
          (
            <Select
              leftSection={<IconBuilding size={15} />}
              placeholder="Empresa"
              data={filterData.companyData.map((x) => {
                return {
                  value: x.idEmpresa.toString(),
                  label: x.empresa,
                };
              })}
              searchable
              clearable={currentUser.executivo}
              disabled={!currentUser.executivo}
              {...form.getInputProps('idEmpresa')}
            />
          ) as any,
        ]}
      />
      <PageContent>
        <Box>
          <Paper shadow="xs" p="md" withBorder>
            <Paper shadow="xs" p="md" withBorder>
              <Grid columns={12}>
                <Grid.Col span={11}>
                  <div>
                    <Input.Wrapper
                      label="Data Inicial / Final"
                      description="Filtro: entre"
                      style={{ marginBottom: 5 }}
                      required
                    >
                      <div />
                    </Input.Wrapper>
                    <DatePickerInput
                      type="range"
                      placeholder="Datas"
                      leftSection={<IconCalendar size={15} />}
                      clearable
                      numberOfColumns={2}
                      allowSingleDateInRange
                      // maxDate={new Date()}
                      required
                      {...form.getInputProps('periodo')}
                    />
                  </div>
                </Grid.Col>
                <Grid.Col span={1}>
                  <div>
                    <Input.Wrapper label="&nbsp;" description="&nbsp;" style={{ marginBottom: 5 }}>
                      <div />
                    </Input.Wrapper>
                    <Button
                      leftSection={<IconSearch size={18} />}
                      color="primary"
                      disabled={form.values.periodo.filter((x) => x).length !== 2}
                      loading={loading}
                      onClick={handleDropFromUrls}
                    >
                      Buscar
                    </Button>
                  </div>
                </Grid.Col>
              </Grid>
            </Paper>
            <Divider label="ou" mt="md" mb="md" />
            <Paper shadow="xs" p="md" withBorder>
              <Dropzone
                onDrop={handleDrop}
                onReject={handleReject}
                maxFiles={500}
                maxSize={5 * 1024 ** 2}
                accept={{ 'application/xml': ['.xml'] }}
                loading={loading}
              >
                <Group justify="center" gap="xl" mih={150} style={{ pointerEvents: 'none' }}>
                  <Dropzone.Accept>
                    <IconFileCheck size={50} stroke={1.5} />
                  </Dropzone.Accept>
                  <Dropzone.Reject>
                    <IconX size={50} stroke={1.5} />
                  </Dropzone.Reject>
                  <Dropzone.Idle>
                    <IconUpload size={50} stroke={1.5} />
                  </Dropzone.Idle>

                  <div>
                    <Text size="xl" inline>
                      Arraste arquivos XML aqui ou clique para selecionar
                    </Text>
                    <Text size="sm" c="dimmed" inline mt={7}>
                      Até 500 arquivos XML de Nota Fiscal Eletrônica
                    </Text>
                  </div>
                </Group>
              </Dropzone>
            </Paper>
          </Paper>
          {result === null ? (
            <></>
          ) : (
            // <Paper mt="md" withBorder p="md">
            //   <Title order={4} mb="md">
            //     NFe(s) importada(s)
            //   </Title>
            //   <>
            //     {buildSummary()}
            //     <Table withTableBorder withColumnBorders>
            //       <Table.Tbody>{buildNFeTable}</Table.Tbody>
            //     </Table>
            //   </>
            // </Paper>

            <Paper mt="md" withBorder p="md">
              <Title order={4} mb="md">
                NFe(s) importada(s)
              </Title>
              <>
                {/* {buildSummary()} */}
                {/* <Accordion
                    multiple
                    variant="contained"
                    defaultValue={result.summary.emitentesDistintos
                      .filter((x) => !x.noContracts)
                      .map((y) => y.cnpj)}
                  > */}
                {buildNFeTable}
                {/* </Accordion> */}
              </>
            </Paper>
          )}
        </Box>
      </PageContent>

      <Affix position={{ bottom: 20, left: '50%' }}>
        <Transition transition="slide-up" mounted={scroll.y > 0}>
          {(transitionStyles) => (
            <Button
              leftSection={<IconArrowNarrowUp size={18} />}
              style={transitionStyles}
              color="secondary"
              onClick={() => scrollTo({ y: 0 })}
            >
              Ir ao topo
            </Button>
          )}
        </Transition>
      </Affix>
    </Card>
  );
}

export default IntegrationNFe;
